const wrapper = hyperform(window, {
	preventImplicitSubmit: true
});

hyperform.setRenderer('attachWarning', function (warning, element) {
	element.parentNode.appendChild(warning);
	element.parentNode.className += ' error-box';
});

const phoneInput = document.getElementById('phone');
let phoneInputMaskedValue = '555-555-5555';
phoneInput.addEventListener('input', handlePhoneInput);
phoneInput.addEventListener('blur', setPhoneInputValue);

function handlePhoneInput(e){
	const phoneInputInitialValue = phoneInput.value;
	const phoneInputNumbersValue = phoneInputInitialValue.replace(/\D/g, '');
	phoneInputMaskedValue = phoneInputNumbersValue.substring(0, 3) + '-' + phoneInputNumbersValue.substring(3, 6) + '-' + phoneInputNumbersValue.substring(6, 10);
}

function setPhoneInputValue(){
	phoneInput.value = phoneInputMaskedValue;
}

document.addEventListener('change', function (event) {
	const theSelect = document.getElementById('selectTypeOfQ');
	theSelect.classList.add('changed');
});

const currentURL = window.location.href.toString();
let redirectURL = currentURL.replace('contact.html', 'contact-thankyou.html');
document.getElementById('redirect').setAttribute('value', redirectURL);



// WEBPACK FOOTER //
// ./src/contact.js